import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, { useTipoApontamento } from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import TMT from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useCoordinates } from "util/geolocation";
import GeolocationButton from "components/form/input/GeolocationButton";
import { useForm } from "react-final-form"

export default function TMTEditFields({ visita, isNew, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(TMT, "Mecanizado", TipoClass), [visita.cliente])

    const [apontamento] = useFieldValue();
    const [coordinates] = useCoordinates();
    const form = useForm()

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado")
        }
    }, [setTipo, tipo])

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = TMT.calcConformidade(apontamento, params);
            form.change("conformidade", TMT.calcConformidade(apontamento, params))

            if (isNew && !apontamento.georeferencia) {
                apontamento.georeferencia = coordinates;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, coordinates, isNew, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} />

            <ApontamentoAmostraParams
                // showTipo={false}
                tipoFixedValue="Mecanizado"
            >
                <FormRow>
                    <TextInput name="operador" label="Operador" />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita} showList={false}>
                <FormRow>
                    <TextInput name="tempoRegistrado" mask="00:00" label="Tempo registrado (mm:ss)" />
                </FormRow>
                <FormRow>
                    <GeolocationButton name="georeferencia" />
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput name="resto" label="Resto (segundos)" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
